import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/utils/i18n';
import { RouteEnum } from '/@/enums/routeEnum';
import { PermissionCodeEnum } from '/@/enums/permissionCodeEnum';
import { STORAGE_KEY } from '/@/constants/storage';

const project: AppRouteModule = {
  path: RouteEnum.PROJECT,
  name: RouteEnum.PROJECT,
  component: LAYOUT,
  redirect: RouteEnum.PROJECT_INDEX,
  meta: {
    hideChildrenInMenu: true,
    icon: 'project|svg',
    title: t('routes.project.project'),
    orderNo: 50,
    permCode: [PermissionCodeEnum.PROJECT_VIEW],
  },
  children: [
    {
      path: 'index',
      name: RouteEnum.PROJECT_INDEX,
      component: () => import('/@/views/project/list/index.vue'),
      meta: {
        title: '',
        // affix: true,
        hideMenu: true,
        keepAlive: true,
      },
    },
    {
      path: 'detail',
      name: RouteEnum.PROJECT_DETAIL,
      component: () => import('/@/views/project/detail/index.vue'),
      meta: {
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        title: t('routes.project.detail'),
        // affix: true,
        hideMenu: true,
        currentActiveMenu: RouteEnum.PROJECT_INDEX,
      },
      children: [
        {
          path: 'batch-config-basic',
          name: RouteEnum.PROJECT_DETAIL_BATCHCONFIG_BASIC,
          component: () => import('/@/views/task/batch-config/basicSettings/index.vue'),
          meta: {
            sessionTitle: STORAGE_KEY.breadcrumbTitle,
            title: t('common.setting'),
            // affix: true,
            hideMenu: true,
            currentActiveMenu: RouteEnum.PROJECT_INDEX,
          },
        },
        {
          path: 'batch-config-ontology',
          name: RouteEnum.PROJECT_DETAIL_BATCHCONFIG_ONTOLOGY,
          component: () => import('/@/views/task/batch-config/ontology/index.vue'),
          meta: {
            sessionTitle: STORAGE_KEY.breadcrumbTitle,
            title: t('common.ontology'),
            // affix: true,
            hideMenu: true,
            currentActiveMenu: RouteEnum.PROJECT_INDEX,
          },
        },
        {
          path: 'batch-config-qa',
          name: RouteEnum.PROJECT_DETAIL_BATCHCONFIG_QA,
          component: () => import('/@/views/task/batch-config/QA/index.vue'),
          meta: {
            sessionTitle: STORAGE_KEY.breadcrumbTitle,
            title: t('common.QARules'),
            // affix: true,
            hideMenu: true,
            currentActiveMenu: RouteEnum.PROJECT_INDEX,
          },
        },
        {
          path: 'batch-config-workflow',
          name: RouteEnum.PROJECT_DETAIL_BATCHCONFIG_WORKFLOW,
          component: () => import('/@/views/task/batch-config/workflow/index.vue'),
          meta: {
            sessionTitle: STORAGE_KEY.breadcrumbTitle,
            title: t('common.workflow'),
            // affix: true,
            hideMenu: true,
            currentActiveMenu: RouteEnum.PROJECT_INDEX,
          },
        },
      ],
    },
    {
      path: 'performance',
      name: RouteEnum.PROJECT_DETAIL_PERFORMANCE,
      component: () => import('/@/views/task/taskPerformance/index.vue'),
      meta: {
        title: 'performance',
        // affix: true,
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        hideMenu: true,
        // keepAlive: true,
        currentActiveMenu: RouteEnum.PROJECT_INDEX,
      },
    },
    {
      path: 'quality',
      name: RouteEnum.PROJECT_DETAIL_QUALITY,
      component: () => import('/@/views/project/qcj/index.vue'),
      meta: {
        title: t('routes.project.quality'),
        // affix: true,
        sessionTitle: STORAGE_KEY.breadcrumbTitle,
        hideMenu: true,
        // keepAlive: true,
        currentActiveMenu: RouteEnum.PROJECT_INDEX,
      },
    },
  ],
};

export default project;
